import { render, staticRenderFns } from "./StartPage.vue?vue&type=template&id=06ee2946&scoped=true&"
import script from "./StartPage.vue?vue&type=script&lang=ts&"
export * from "./StartPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ee2946",
  null
  
)

export default component.exports